import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { BooleanForm } from '../forms/BooleanForm';
import TOOL_NAMES from '../../../tools/constants/toolNames';
import * as commands from '../../../tools/commands';

export function BooleanCompute({
  createPainters,
  popActivePainters,
  ROIContours,
  addNewROIContourWithName,
  onCommand,
  onFinished,
}) {
  const [activePainters, setActivePainters] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);
  const isSubmitting = useRef(false);
  const isDeleting = useRef(false);

  const onFormCreate = () => {
    onCommand('setToolActive', { toolName: TOOL_NAMES.BOOLEAN_TOOL });
    const painters = createPainters('boolean-operation');
    setActivePainters(painters);
  };

  const onFormSelectChange = ({
    subjectROIContour,
    objectROIContour,
    method,
  }) => {
    if (!subjectROIContour || !objectROIContour || !method) return;
    commands.refreshViewport();
    for (let i = 0; i < activePainters.length; i++) {
      activePainters[i].update({
        subjectROINumber: subjectROIContour.ROINumber,
        objectROINumber: objectROIContour.ROINumber,
        method: method,
      });
    }
  };

  const onFormSubmit = ({
    name,
    subjectROIContour,
    objectROIContour,
    method,
  }) => {
    try {
      if (!name) throw new Error('ROI Name is empty');
      if (!subjectROIContour) {
        throw new Error('Please select a subject ROI Contour');
      }
      if (!objectROIContour) {
        throw new Error('Please select an object ROI Contour');
      }
      if (!method) {
        throw new Error('Please select a boolean operation method');
      }
      const newROINumber = addNewROIContourWithName(name);
      if (newROINumber === -1) throw new Error(`ROI ${name} already exists`);
      for (let i = 0; i < activePainters.length; i++) {
        activePainters[i].commit({ booleanROINumber: newROINumber });
      }
      commands.refreshViewport();
      isSubmitting.current = true;
      onFinished();
    } catch (error) {
      setErrorMessage(error.message);
    }
  };

  const onFormDelete = () => {
    isDeleting.current = true;
    popActivePainters();
    onFinished();
  };

  useEffect(() => {
    onFormCreate();
    return () => {
      if (!isSubmitting.current && !isDeleting.current) popActivePainters();
    };
  }, []);

  return (
    <BooleanForm
      ROIContours={ROIContours}
      onSelectChange={onFormSelectChange}
      onSubmit={onFormSubmit}
      onDelete={onFormDelete}
      errorMessage={errorMessage}
    />
  );
}
BooleanCompute.propTypes = {
  createPainters: PropTypes.func,
  popActivePainters: PropTypes.func,
  ROIContours: PropTypes.arrayOf(
    PropTypes.shape({ ROINumber: PropTypes.number })
  ),
  addNewROIContourWithName: PropTypes.func,
  onCommand: PropTypes.func,
  onFinished: PropTypes.func,
};
